import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { DataService, OptionsserviceService, LoansService, StorageService, CustomerService, OperationsService } from '../_services/index';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { IMyDpOptions } from 'mydatepicker';
import { IMyDateModel, IMyInputFieldChanged, IMyCalendarViewChanged, IMyInputFocusBlur, IMyMarkedDate, IMyDate, IMySelector } from 'mydatepicker';

@Component({
  selector: 'app-bookloanform',
  templateUrl: './bookloanform.component.html',
  styleUrls: ['./bookloanform.component.css']
})

export class BookloanformComponent implements OnInit {
  disdate = false;
  repdate = false;
  loading = false;
  searchText = '';
  searchedCustomerResult = [];
  @Input('customer') customer: any;
  @Input('view') view: String = 'request';
  @Input('contract_details') contract_details: any;
  @Input('editing_contract') editing_contract = false;
  @Input('request') request = {
    'request_id': '',
    'request_principal': '0',
    'request_tenor': '1',
    'request_period_id': '2',
    'request_rate': '40',
    'request_rate_period_id': '3',
    'loan_purpose_id': '',
    'comments': '',
    'people_id': '',
    'connected_card_id': '',
    'connected_account_id': '',
    'loan_product_id': '',
    'disbursement_date': '2019-03-10',
    'repayment_started_when': '',
    'installment_frequency': '2',
    'repayment_type_id': '1',
    'monthly_period': '1',
    'interest_rate_type_id': '1',
    'rp_set_type': '1',
    'allow_moratorium': '0',
    'moratorium_type': '0',
    'moratorium_period': '0',
    'total_flat_fees': '0',
    'total_percentage_fees': '0',
    'days_per_year': '1',
    'fee_type': '0',
    'schedule_has_been_created':false
  };
  @Input('request_id') request_id: any;
  @Input('customer_selected') customer_selected = false;
  @Input('searchString') searchString = '';
  @Input('customers') customers: any;
  @Input('loan_products') loan_products: any;
  @Input('product') product: any;
  currentUser: any;
  hasSelectedCustomer = false;
  countries: any;
  appsettings: any;
  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    height: '34px',
    width: '100%',
    dateFormat: 'yyyy-mm-dd',
    openSelectorTopOfInput: false,
  };
 // public selDate: IMyDate = { year: 0, month: 0, day: 0 };
  //public selDate_: IMyDate = { year: 0, month: 0, day: 0 };
  public selDate: any = { date: { year: 0, month: 0, day: 0 } };
  public selDate_: any = { date: { year: 0, month: 0, day: 0 } };
  gender = [
    { value: 0, display: 'Male' },
    { value: 1, display: 'Female' }
  ];
  marital_status = [
    { value: 0, display: '' },
    { value: 1, display: 'Single' },
    { value: 2, display: 'Married' },
    { value: 3, display: 'Widowed' }
  ];

  id_means = [
    { value: 0, display: '' },
    { value: 1, display: 'International Passport' },
    { value: 2, display: 'Voters Id' },
    { value: 3, display: 'Work Id' },
    { value: 4, display: 'National Id' }
  ];
  relations = [
    { value: 0, display: '' },
    { value: 1, display: 'Father' },
    { value: 2, display: 'Mother' },
    { value: 3, display: 'Brother' },
    { value: 4, display: 'Sister' },
    { value: 5, display: 'Uncle' },
    { value: 6, display: 'Aunty' },
    { value: 7, display: 'Husband' },
    { value: 8, display: 'Wife' },
    { value: 9, display: 'Son' },
    { value: 10, display: 'Daughter' }
  ];
  edu_qua = [
    { value: 0, display: '' },
    { value: 1, display: 'Professor' },
    { value: 2, display: 'Ph D' },
    { value: 3, display: 'Masters' },
    { value: 4, display: 'B Sc' },
    { value: 5, display: 'NCE' },
    { value: 6, display: 'High School' },
    { value: 7, display: 'Primary School' }
  ];
  public installment_frequency = '1';
  public installment_frequencies = [{ value: '1', display: 'One Off' }, { value: '2', display: 'Monthly' }];
  occupations: any;
  sectors: any;
  designations: any;
  nigerian_banks: any;
  has_loan_products = '0';
  public loan_currency = 'NGN';
  public loan_duration = 'Months';
  public interest_duration = 'Per Month';
  public loan_durations = [
    { 'LOAN_INTEREST_DURATION_ID': '1', 'LOAN_DURATION': 'Days', 'INTEREST_DURATION': 'Per Day', 'ADJECTIVAL': 'Daily', 'ABBREV': 'd' },
    { 'LOAN_INTEREST_DURATION_ID': '2', 'LOAN_DURATION': 'Months', 'INTEREST_DURATION': 'Per Month', 'ADJECTIVAL': 'Monthly', 'ABBREV': 'Mo' },
    { 'LOAN_INTEREST_DURATION_ID': '3', 'LOAN_DURATION': 'Years', 'INTEREST_DURATION': 'Per Year', 'ADJECTIVAL': 'Yearly', 'ABBREV': 'Yr' },
    { 'LOAN_INTEREST_DURATION_ID': '4', 'LOAN_DURATION': 'Weeks', 'INTEREST_DURATION': 'Per Week', 'ADJECTIVAL': 'Weekly', 'ABBREV': 'Wk' }];
  customerSelected = false;
  @Input() selectedCustomer: any;
  searchForCustomer = false;
  searchingForCustomers = false;
  SEND_CONTRACT_DOCS = false;
  allow_moratorium = false;
  bullet = false;
  interestAlone = false;
  epi = false;
  submitted = false;
  public rtypes = [
    { value: 1, display: 'Equal Monthly Installment' },
    { value: 2, display: 'Interest Alone' },
    { value: 6, display: 'Reducing Balance' }];
  public oneoff_types = [{ value: 3, display: 'Bullet' }];
  constructor(private dataService: DataService, public router: Router,
    public storageService: StorageService, public customerService: CustomerService,
    public optionsService: OptionsserviceService, public loansService: LoansService,
    private operationsService: OperationsService,
    private toastr: ToastrService) {
    this.currentUser = this.storageService.read<any>('currentUser');
  }

  ngOnInit() {
    this.optionsService.getCountries().subscribe(countries => this.countries = countries);
    this.optionsService.getOccupation(2).subscribe(sectors => this.sectors = sectors);
    this.optionsService.getOccupation(1).subscribe(sectors => this.occupations = sectors);
    this.optionsService.getOccupation(4).subscribe(sectors => this.designations = sectors);
    this.operationsService.getNigerianBanks(this.currentUser.token).subscribe(nigerian_banks => this.nigerian_banks = nigerian_banks);
    this.optionsService.getLoanProducts(this.currentUser.token).subscribe(data => {
      this.has_loan_products = data.has_loan_products;
      if (data.has_loan_products === '0') {
        this.product = data.data;
        this.request.loan_product_id = data.data.loan_product_id;
        this.request.request_rate = data.data.loan_interest;
        this.request.request_rate_period_id = data.data.loan_interest_type;
        this.request.request_period_id = data.data.loan_duration_type;
        this.request.request_tenor = data.data.loan_duration;
        this.request.request_principal = '0';
        this.request.days_per_year = data.data.days_per_year;
        this.request.monthly_period = data.data.monthly_period;
        this.request.interest_rate_type_id = data.data.interest_rate_type_id;
        this.request.repayment_type_id = data.data.repayment_type_id;
        this.request.installment_frequency = data.data.installment_frequency;
        this.request.rp_set_type = data.data.rp_set_type;
        this.request.fee_type = data.data.fee_type;
        this.request.total_flat_fees = data.data.total_flat_fees;
        this.request.total_percentage_fees = data.data.total_percentage_fees;
        this.request.installment_frequency = data.data.installment_frequency;
        this.request.allow_moratorium = '0';
        this.request.moratorium_type = '1';
        this.request.moratorium_period = '0';
        this.request.schedule_has_been_created = false;
        let d: Date = new Date(this.request.disbursement_date);

        this.selDate = {date:{
          year: d.getFullYear(),
          month: d.getMonth() + 1,
          day: d.getDate()
        }
        };
        let d_: Date = new Date(this.request.repayment_started_when);

        this.selDate_ = {date:{
          year: d_.getFullYear(),
          month: d_.getMonth() + 1,
          day: d_.getDate()
        }
        };
      } else {
        this.loan_products = data.data;
      }
      this.SEND_CONTRACT_DOCS = data.send_docs;
      this.initializeForm();
    });
  }
  initializeForm() {
    if (this.editing_contract) {
      this.request.request_id = this.contract_details.loan.request_id;
      this.request.people_id = this.contract_details.loan.people_id;
      this.request.loan_product_id = this.contract_details.loan.loan_product_id;
      this.request.request_rate = this.contract_details.loan.request_rate;
      this.request.request_rate_period_id = this.contract_details.loan.request_rate_period_id;
      this.request.request_period_id = this.contract_details.loan.request_period_id;
      this.request.request_tenor = this.contract_details.loan.request_tenor;
      this.request.request_principal = this.contract_details.loan.request_principal;
      this.request.days_per_year = this.contract_details.loan.days_per_year;
      this.request.monthly_period = this.contract_details.loan.monthly_period;
      this.request.interest_rate_type_id = this.contract_details.loan.interest_rate_type_id;
      this.request.repayment_type_id = this.contract_details.loan.repayment_type_id;
      this.request.installment_frequency = this.contract_details.loan.installment_frequency;
      this.request.rp_set_type = this.contract_details.loan.rp_set_type;
      this.request.fee_type = this.contract_details.loan.fee_type;
      this.request.total_flat_fees = this.contract_details.loan.total_flat_fees;
      this.request.total_percentage_fees = this.contract_details.loan.total_percentage_fees;
      this.request.installment_frequency = this.contract_details.loan.installment_frequency;
      this.request.allow_moratorium = this.contract_details.loan.allow_moratorium;
      this.request.moratorium_type = this.contract_details.loan.moratorium_type;
      this.request.moratorium_period = this.contract_details.loan.moratorium_period;
      this.interest_duration = this.contract_details.loan.interest_duration;
      this.loan_duration = this.contract_details.loan.loan_duration;
      this.request.disbursement_date = this.contract_details.loan.disbursement_date;
      this.request.repayment_started_when = this.contract_details.loan.repayment_started_when;
      this.request.schedule_has_been_created = this.contract_details.loan.schedule_has_been_created;
      let d: Date = new Date(this.contract_details.loan.disbursement_date);

      this.selDate = {date:{
        year: d.getFullYear(),
        month: d.getMonth() + 1,
        day: d.getDate()
      }
      };
      let d_: Date = new Date(this.contract_details.loan.repayment_started_when);

      this.selDate_ = {date:{
        year: d_.getFullYear(),
        month: d_.getMonth() + 1,
        day: d_.getDate()
      }
      };
      //console.log(this.selDate_,this.selDate)
    }
  }
  changeView(view) {
    this.view = view;
  }
  changeLoanProduct(product) {
    this.request.loan_product_id = product.loan_product_id;
    this.request.request_rate = product.loan_interest;
    this.request.request_rate_period_id = product.loan_interest_type;
    this.request.request_period_id = product.loan_duration_type;
    this.request.request_tenor = product.loan_duration;
    this.request.request_principal = '0';
    this.request.days_per_year = product.days_per_year;
    this.request.monthly_period = product.monthly_period;
    this.request.interest_rate_type_id = product.interest_rate_type_id;
    this.request.repayment_type_id = product.repayment_type_id;
    this.request.installment_frequency = product.installment_frequency;
    this.request.rp_set_type = product.rp_set_type;
    this.request.fee_type = product.fee_type;
    this.request.total_flat_fees = product.total_flat_fees;
    this.request.total_percentage_fees = product.total_percentage_fees;
    this.request.installment_frequency = product.installment_frequency;
    this.request.allow_moratorium = '0';
    this.request.moratorium_type = '1';
    this.request.moratorium_period = '0';
    this.product = product;
  }
  changeDuration(d, T) {
    if (T === 1) {
      this.loan_duration = this.loan_durations[d]['LOAN_DURATION'];
      this.request.request_period_id = this.loan_durations[d]['LOAN_INTEREST_DURATION_ID'];
    }
    if (T === 2) {

      this.interest_duration = this.loan_durations[d]['INTEREST_DURATION'];
      this.request.request_rate_period_id = this.loan_durations[d]['LOAN_INTEREST_DURATION_ID'];

    }

  }
  searchCustomers() {
    this.searchingForCustomers = true;
    if (this.searchString == '') {
      this.searchedCustomerResult = [];
    } else {
      this.customerService.searchForCustomers(this.currentUser.token, this.searchString, '')
        .subscribe(customers => {
          this.searchedCustomerResult = customers;
          this.searchingForCustomers = false;
        });
    }

  }
  selectCustomer(customer) {
    this.selectedCustomer = customer;
    this.customerSelected = true;
    this.searchForCustomer = false;
    this.request.people_id = customer.PEOPLE_CUSTOMERS_ID;
    this.hasSelectedCustomer = true;
    this.customer_selected = true;
    this.searchedCustomerResult = [];
    this.searchString = '';
  }
  previewLoan() {
    this.loading = true;
    this.loansService.startRequest(this.currentUser.token, this.request, this.selectedCustomer, this.product).subscribe(loan_request => {
      this.loading = false;
      this.request = loan_request;
    });
  }
  changeInstallmentFrequency(event) {

    this.installment_frequency = event;

    this.allow_moratorium = false;
    this.request.allow_moratorium = '1';
    if (this.installment_frequency === '1') {
      this.rtypes = [{ value: 3, display: 'Bullet' }];
      this.request.repayment_type_id = '3';
      this.contract_details.loan.repayment_type = 'Bullet';
    } else {
      this.rtypes = [
        { value: 1, display: 'Equal Monthly Installment' },
        { value: 2, display: 'Interest Alone' },
        { value: 6, display: 'Reducing Balance' }
      ];
      this.request.repayment_type_id = '1';
      this.contract_details.loan.repayment_type = 'EPI';
    }

  }
  changeRepay(event) {
    this.allow_moratorium = false;
    this.request.allow_moratorium = '1';
    if (event == '1') {
      this.rtypes = [{ value: 1, display: 'Equal Monthly Installment' }];
    }
    if (event == '2') {
      this.rtypes = [
        { value: 1, display: 'Equal Monthly Installment' },
        { value: 2, display: 'Interest Alone' },
        { value: 6, display: 'Reducing Balance' }];
    }
  }
  cIA(event) {

    this.interestAlone = false;
    this.epi = false;
    this.bullet = false;
    this.allow_moratorium = false;
    this.request.allow_moratorium = '1';
    if (event == '2') {
      this.interestAlone = true;
      this.epi = false;
      this.contract_details.loan.repayment_type = 'Interest Alone';
      this.request.interest_rate_type_id = '2';
    }
    if (event == '1') {
      this.epi = true;
      this.contract_details.loan.repayment_type = 'EPI';
    }
    if (event == '3') {
      this.bullet = true;
    }
    if (event == '6') {
      this.request.interest_rate_type_id = '2';
      this.contract_details.loan.repayment_type = 'Reducing Balance';
    }
  }
  cIB(event) {

    this.allow_moratorium = false;

    if (event == '2') {
      this.allow_moratorium = true;
    }
  }
  onDateChanged(event) { 
    this.submitted = true;
    const data = {
      'DISBURSEMENT_DATE': event,
      'REQUEST_PERIOD_ID': this.request.request_period_id,
      'MONTHLY_PERIOD': this.request.monthly_period,
      'DAYS_PER_YEAR': this.request.days_per_year,
    }
    this.loansService.modify_repay_dated(data)
      .subscribe(loan => {
        this.request.disbursement_date = loan.disburse;
        this.request.repayment_started_when = loan.repay;
      });
  }
  getNet(loan_request) {
    // let total = parseInt(request.request_principal);
    // if (request.fee_type === '0') {
    //   total -= parseInt(request.total)
    // }
    // return total;
  }
  doInvest() {
    this.loading = true;
    this.loansService.doInvest(this.currentUser.token, this.request)
      .subscribe(res => {
        this.loading = false;
        this.view = 'schedule';
        this.showSuccess('Contract Updated');
        this.dataService.contractHasBeenCreated.emit();
      });
  }
  showSuccess(message) {
    this.toastr.success(message, 'Success!');
  }

  showError(message) {
    this.toastr.error(message, 'Error');
  }
  viewContract(){
    this.dataService.showScheduleDetails.emit({request_id:this.request.request_id});
  }
}
